export default {
  light: {
    primaryPurple: '#4800A5',
    primaryTurquoise: '#17A4E0',
  },
  dark: {},
};
